<template>
  <ContentWrap>
    <!-- 暂隐藏现场扫码核销入口
    <el-alert
      v-if="checkinPage"
      title="现场签到核销"
      type="info"
      :closable="false"
      class="mb-16px"
    />
    <el-form v-if="checkinPage" inline>
      <el-form-item label="扫码结果"
        ><el-input
          v-model="checkinCode"
          placeholder="扫描二维码或输入核销码"
          class="!w-360px"
          @keyup.enter="verifyCode"
      /></el-form-item>
      <el-button
        type="primary"
        :disabled="!queryParams.activityId || !checkinCode"
        @click="verifyCode"
        ><Icon icon="ep:circle-check" />确认核销</el-button
      >
    </el-form>
    -->
    <el-form :inline="true" :model="queryParams" class="-mb-15px">
      <el-form-item label="活动" prop="activityId">
        <el-select
          v-model="queryParams.activityId"
          placeholder="请选择活动"
          clearable
          filterable
          class="!w-200px"
        >
          <el-option v-for="a in activityList" :key="a.id" :label="a.title" :value="a.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input
          v-model="queryParams.name"
          placeholder="请输入姓名"
          clearable
          class="!w-150px"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="联系电话" prop="mobile">
        <el-input
          v-model="queryParams.mobile"
          placeholder="请输入手机号"
          clearable
          class="!w-150px"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="queryParams.status" placeholder="请选择" clearable class="!w-130px">
          <el-option label="待支付" :value="4" />
          <el-option label="待审核" :value="2" />
          <el-option label="已拒绝" :value="3" />
          <el-option label="已报名" :value="1" />
          <el-option label="取消" :value="0" />
        </el-select>
      </el-form-item>
      <el-form-item label="签到" prop="isSign">
        <el-select v-model="queryParams.isSign" placeholder="请选择" clearable class="!w-130px">
          <el-option label="已签到" :value="1" />
          <el-option label="未签到" :value="0" />
        </el-select>
      </el-form-item>
      <el-form-item label="报名时间" prop="addTime">
        <el-date-picker
          v-model="queryParams.addTime"
          type="datetimerange"
          range-separator="-"
          start-placeholder="开始"
          end-placeholder="结束"
          value-format="YYYY-MM-DD HH:mm:ss"
          class="!w-350px"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleQuery"><Icon icon="ep:search" /> 搜索</el-button>
        <el-button @click="resetQuery"><Icon icon="ep:refresh" /> 重置</el-button>
        <el-button
          type="primary"
          plain
          @click="openForm('create')"
          v-hasPermi="['activity:signup:create']"
        >
          <Icon icon="ep:plus" /> 新增报名
        </el-button>
      </el-form-item>
    </el-form>

    <el-table v-loading="loading" :data="list" border>
      <el-table-column label="序号" prop="ranking" width="60" align="center" />
      <el-table-column label="头像" width="72" align="center">
        <template #default="scope">
          <el-avatar
            v-if="scope.row.avatar"
            :src="scope.row.avatar"
            :size="36"
            shape="circle"
          />
          <el-avatar v-else :size="36" shape="circle">
            {{ (scope.row.name || '?').slice(0, 1) }}
          </el-avatar>
        </template>
      </el-table-column>
      <el-table-column label="姓名" prop="name" width="100" />
      <el-table-column label="联系电话" prop="mobile" width="130" />
      <el-table-column label="公司名称" prop="companyName" min-width="180" show-overflow-tooltip />
      <el-table-column label="职位" prop="career" width="100" />
      <el-table-column
        label="主要业务"
        prop="businessSphere"
        min-width="180"
        show-overflow-tooltip
      />
      <el-table-column label="邀请人" prop="shareName" width="100" />
      <el-table-column label="状态" prop="status" width="80">
        <template #default="scope">
          <el-tag :type="getStatusType(scope.row.status)">
            {{ getStatusText(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="签到" prop="isSign" width="80">
        <template #default="scope">
          <el-tag v-if="scope.row.isSign === 1" type="success">已签到</el-tag>
          <el-tag v-else type="info">未签到</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="签到时间" prop="signTime" width="170" :formatter="dateFormatter" />
      <el-table-column label="报名时间" prop="addTime" width="170" :formatter="dateFormatter" />
      <el-table-column label="操作" align="center" width="200" fixed="right">
        <template #default="scope">
          <el-button
            v-if="scope.row.status === 2"
            link
            type="success"
            v-hasPermi="['activity:signup:update']"
            @click="handleAudit(scope.row.id, true)"
            >通过</el-button
          >
          <el-button
            v-if="scope.row.status === 2"
            link
            type="danger"
            v-hasPermi="['activity:signup:update']"
            @click="handleAudit(scope.row.id, false)"
            >拒绝</el-button
          >
          <el-button
            link
            type="primary"
            @click="openForm('update', scope.row.id)"
            v-hasPermi="['activity:signup:update']"
          >
            编辑
          </el-button>
          <el-button
            v-if="scope.row.isSign !== 1"
            link
            type="success"
            @click="handleSign(scope.row.id, 1)"
            v-hasPermi="['activity:signup:update']"
          >
            签到
          </el-button>
          <el-button
            v-else
            link
            type="warning"
            @click="handleSign(scope.row.id, 0)"
            v-hasPermi="['activity:signup:update']"
          >
            取消签到
          </el-button>
          <el-button
            link
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-hasPermi="['activity:signup:delete']"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <Pagination
      v-model:page="queryParams.pageNo"
      v-model:limit="queryParams.pageSize"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <!-- 报名表单弹窗 -->
  <Dialog v-model="dialogVisible" :title="dialogTitle" width="600px">
    <el-form ref="formRef" :model="formData" :rules="formRules" label-width="100px">
      <el-form-item label="活动" prop="activityId">
        <el-select
          v-model="formData.activityId"
          placeholder="请选择活动"
          filterable
          class="!w-full"
        >
          <el-option v-for="a in activityList" :key="a.id" :label="a.title" :value="a.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="头像" prop="avatar">
        <UploadImg
          v-model="formData.avatar"
          directory="activity/signup"
          height="80px"
          width="80px"
        />
        <div class="mt-4px text-12px text-gray-400">可选；用于报名名单展示</div>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="formData.name" placeholder="请输入姓名" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="mobile">
            <el-input v-model="formData.mobile" placeholder="请输入联系电话" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="公司名称" prop="companyName">
            <el-input v-model="formData.companyName" placeholder="请输入公司名称" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="职位" prop="career">
            <el-input v-model="formData.career" placeholder="请输入职位" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="主要业务" prop="businessSphere">
        <el-input
          v-model="formData.businessSphere"
          type="textarea"
          :rows="2"
          placeholder="请输入主要业务"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="formData.status">
          <el-radio :value="1">已报名</el-radio>
          <el-radio :value="0">取消</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="submitForm">确 定</el-button>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import { dateFormatter } from '@/utils/formatTime'
import { UploadImg } from '@/components/UploadFile'
import * as SignupApi from '@/api/activity/signup'
import * as ActivityApi from '@/api/activity/activity'

defineOptions({ name: 'ActivitySignup' })

const route = useRoute()
const checkinPage = computed(() => route.path.endsWith('/checkin'))
const checkinCode = ref('')
const message = useMessage()
const getStatusText = (status: number) =>
  ({ 0: '取消', 1: '已报名', 2: '待审核', 3: '已拒绝', 4: '待支付' })[status] || '-'
const getStatusType = (status: number) =>
  ({ 0: 'info', 1: 'success', 2: 'warning', 3: 'danger', 4: 'warning' })[status] || 'info'
const verifyCode = async () => {
  const code = checkinCode.value.replace(/^ACTIVITY_CHECKIN:/, '').trim()
  await SignupApi.verifyCheckinCode(code, queryParams.activityId as number)
  message.success('核销成功')
  checkinCode.value = ''
  getList()
}
const loading = ref(true)
const list = ref<any[]>([])
const total = ref(0)
const activityList = ref<any[]>([])

const queryParams = reactive({
  pageNo: 1,
  pageSize: 20,
  activityId: undefined as number | undefined,
  name: '',
  mobile: '',
  status: undefined as number | undefined,
  isSign: undefined as number | undefined,
  addTime: [] as string[]
})

// 从路由 query 接收筛选条件（概况页待办会带 status）
if (route.query.activityId) {
  queryParams.activityId = Number(route.query.activityId)
}
if (route.query.status !== undefined && route.query.status !== '') {
  const status = Number(route.query.status)
  if (!Number.isNaN(status)) {
    queryParams.status = status
  }
}
if (route.query.isSign !== undefined && route.query.isSign !== '') {
  const isSign = Number(route.query.isSign)
  if (!Number.isNaN(isSign)) {
    queryParams.isSign = isSign
  }
}

const getList = async () => {
  loading.value = true
  try {
    const params: any = { ...queryParams }
    if (!params.addTime || params.addTime.length !== 2) {
      delete params.addTime
    }
    const data = await SignupApi.getSignupPage(params)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}

const loadActivityList = async () => {
  try {
    const data = await ActivityApi.getActivityListAll()
    activityList.value = data || []
  } catch (e) {
    activityList.value = []
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}
const resetQuery = () => {
  queryParams.activityId = undefined
  queryParams.name = ''
  queryParams.mobile = ''
  queryParams.status = undefined
  queryParams.isSign = undefined
  queryParams.addTime = []
  handleQuery()
}

onMounted(() => {
  // 概况页等入口已通过 query.status 注入筛选时，不再被路径后缀覆盖
  if (route.query.status === undefined || route.query.status === '') {
    if (route.path.endsWith('/audit')) {
      queryParams.status = 2
    } else if (route.path.endsWith('/checkin')) {
      queryParams.status = 1
    }
  }
  loadActivityList()
  getList()
})

// ===== 弹窗 =====
const dialogVisible = ref(false)
const dialogTitle = ref('')
const submitLoading = ref(false)
const formRef = ref()
const formData = reactive<any>({
  id: undefined,
  activityId: undefined,
  ranking: 0,
  memberId: 0,
  name: '',
  mobile: '',
  avatar: '',
  career: '',
  companyName: '',
  businessSphere: '',
  shareId: 0,
  shareName: '',
  status: 1,
  isSign: 0
})
const formRules = {
  activityId: [{ required: true, message: '请选择活动', trigger: 'change' }],
  name: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
  mobile: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
  status: [{ required: true, message: '请选择状态', trigger: 'change' }]
}

const openForm = async (type: 'create' | 'update', id?: number) => {
  dialogVisible.value = true
  dialogTitle.value = type === 'create' ? '新增报名' : '编辑报名'
  resetForm()
  if (id) {
    const data = await SignupApi.getSignup(id)
    Object.assign(formData, data)
  }
}

const resetForm = () => {
  Object.assign(formData, {
    id: undefined,
    activityId: undefined,
    ranking: 0,
    memberId: 0,
    name: '',
    mobile: '',
    avatar: '',
    career: '',
    companyName: '',
    businessSphere: '',
    shareId: 0,
    shareName: '',
    status: 1,
    isSign: 0
  })
  formRef.value?.clearValidate()
}

const submitForm = async () => {
  await formRef.value?.validate()
  submitLoading.value = true
  try {
    if (formData.id) {
      await SignupApi.updateSignup(formData)
      message.success('修改成功')
    } else {
      await SignupApi.createSignup(formData)
      message.success('新增成功')
    }
    dialogVisible.value = false
    getList()
  } finally {
    submitLoading.value = false
  }
}

const handleDelete = async (id: number) => {
  await message.confirm('确定删除该报名记录？')
  await SignupApi.deleteSignup(id)
  message.success('删除成功')
  getList()
}

const handleAudit = async (id: number, pass: boolean) => {
  let reason = ''
  if (!pass) {
    const result = await ElMessageBox.prompt('请输入拒绝原因', '拒绝报名', {
      inputValidator: (value) => !!value?.trim() || '拒绝原因不能为空'
    })
    reason = result.value
  } else {
    await message.confirm('确定通过该报名申请？')
  }
  await SignupApi.auditSignup({ id, pass, reason })
  message.success('审核完成')
  getList()
}

const handleSign = async (id: number, isSign: number) => {
  try {
    if (isSign === 1) {
      await message.confirm('确认将该报名记为已签到？')
      await SignupApi.signinSignup(id)
      message.success('签到成功')
    } else {
      await message.confirm('确认取消该报名的签到状态？')
      await SignupApi.cancelSigninSignup(id)
      message.success('已取消签到')
    }
    getList()
  } catch (e: any) {
    // 用户取消确认框不提示；业务失败由 axios 拦截器弹出后端友好文案
    if (e === 'cancel' || e === 'close' || e?.message === 'cancel') {
      return
    }
  }
}
</script>
